import { Directive, ElementRef, Input, OnChanges, OnInit } from "@angular/core";

import { SessionService } from "../../common/services/session.service";
import { SharedService } from "../service/api/shared.service";

@Directive({
  selector: "[appFeaturePermission]",
})
export class FeaturePermissionDirective implements OnInit, OnChanges {
  @Input("appFeaturePermission") data: any;

  permissionData: any;
  userInfo: any;

  constructor(
    private el: ElementRef,
    private sharedService: SharedService,
    private ss: SessionService
  ) {
    this.userInfo = this.ss.getUserInfo();
  }

  permissionSet() {
    this.permissionData = this.ss.getAuthPermission();

    let menu = this.permissionData.find((ele) => ele.name === this.data.menu);
    if (this.userInfo.role == "SYSTEM_ADMIN") {
      return true;
    } else {
      if (menu) {
        let add = menu.permissions.find(
          (ele) => ele.name === this.data.feature
        );
        if (add) {
          return true;
        } else {
          this.el.nativeElement.style.visibility = "hidden";
        }
      }
    }
  }

  ngOnChanges() {
    if (this.userInfo.role !== "SYSTEM_ADMIN") {
      this.permissionSet();
    }
  }

  ngOnInit() {}
}
